import { render, staticRenderFns } from "./StatisticsTotalUser.vue?vue&type=template&id=0717f0c4&scoped=true&"
import script from "./StatisticsTotalUser.vue?vue&type=script&lang=js&"
export * from "./StatisticsTotalUser.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTotalUser.vue?vue&type=style&index=0&id=0717f0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0717f0c4",
  null
  
)

export default component.exports